/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown> }} Plan_Build_Ask_Suggestions_EmptyInputs */

const en_us2_plan_build_ask_suggestions_empty = /** @type {(inputs: Plan_Build_Ask_Suggestions_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I'm building ${i?.session} of my plan, and it's still empty. What would you put in it? Show me options to choose from.`)
};

const pt_br2_plan_build_ask_suggestions_empty = /** @type {(inputs: Plan_Build_Ask_Suggestions_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estou montando o ${i?.session} do meu plano, que ainda está vazio. O que você sugere colocar nele? Me mostre opções para eu escolher.`)
};

const es_419_plan_build_ask_suggestions_empty = /** @type {(inputs: Plan_Build_Ask_Suggestions_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estoy armando el ${i?.session} de mi plan, y todavía está vacío. ¿Qué le pondrías? Muéstrame opciones para elegir.`)
};

const pt_pt2_plan_build_ask_suggestions_empty = /** @type {(inputs: Plan_Build_Ask_Suggestions_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estou a montar o ${i?.session} do meu plano, que ainda está vazio. O que sugeres pôr nele? Mostra-me opções para eu escolher.`)
};

const fr_fr2_plan_build_ask_suggestions_empty = /** @type {(inputs: Plan_Build_Ask_Suggestions_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je construis ${i?.session} de mon programme, et elle est encore vide. Qu'est-ce que tu y mettrais ? Montre-moi des options à choisir.`)
};

const de_de2_plan_build_ask_suggestions_empty = /** @type {(inputs: Plan_Build_Ask_Suggestions_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ich baue gerade ${i?.session} meines Plans, und es ist noch leer. Was würdest du hineinnehmen? Zeig mir Optionen zur Auswahl.`)
};

const it_it2_plan_build_ask_suggestions_empty = /** @type {(inputs: Plan_Build_Ask_Suggestions_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sto creando ${i?.session} della mia scheda, ed è ancora vuoto. Cosa ci metteresti? Mostrami delle opzioni tra cui scegliere.`)
};

/**
* | output |
* | --- |
* | "I'm building {session} of my plan, and it's still empty. What would you put in it? Show me options to choose from." |
*
* @param {Plan_Build_Ask_Suggestions_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_ask_suggestions_empty = /** @type {((inputs: Plan_Build_Ask_Suggestions_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Ask_Suggestions_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_ask_suggestions_empty(inputs)
	if (locale === "es-419") return es_419_plan_build_ask_suggestions_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_ask_suggestions_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_ask_suggestions_empty(inputs)
	if (locale === "de-DE") return de_de2_plan_build_ask_suggestions_empty(inputs)
	if (locale === "it-IT") return it_it2_plan_build_ask_suggestions_empty(inputs)
	return en_us2_plan_build_ask_suggestions_empty(inputs)
});
export { plan_build_ask_suggestions_empty as "plan-build.ask_suggestions_empty" }